import Image from 'next/image'
import richmond_alake from '/public/images/richmond_alake.jpeg'
import raymond_alake from '/public/images/raymond_alake.jpg'
import { Button } from '../components/common/Button';

const team = [
  {
    name: 'Richmond Alake',
    role: 'Co-Founder / Machine Learning Engineer',
    imageUrl: richmond_alake
  },
  {
    name: 'Raymond Alake',
    role: 'Co-Founder / Software Engineer',
    imageUrl: raymond_alake
  }
]

export default function About() {

  return (
    <main className="relative isolate">
      {/* Header section */}
      <div className="px-6 pt-16 lg:px-8">
        <h1 className="mx-auto max-w-4xl text-center text-5xl font-bold tracking-tight">
          Elevating your audio content creation to the next level.
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-center leading-8 text-gray-600">
          "At OpenSpeech, we're passionate about empowering your voice. With our innovative tools, we're streamlining the path from audio to diverse written content. We go beyond simple transcription, helping you seamlessly create impactful social media posts and other narratives from your audio. Our goal is to unlock the potential of your auditory storytelling, enhancing its reach and versatility. </p>      </div>

      {/* Stats section */}
      {/* <AboutStats /> */}

      {/* Content section */}
      <section className="isolate overflow-hidden bg-white px-6 lg:px-8">
        <div className="relative mx-auto max-w-2xl py-24 sm:py-32 lg:max-w-4xl">
          <div className="absolute left-1/2 top-0 -z-10 h-[50rem] w-[90rem] -translate-x-1/2 bg-[radial-gradient(50%_100%_at_top,theme(colors.indigo.100),white)] opacity-20 lg:left-36" />
          <div className="absolute inset-y-0 right-1/2 -z-10 mr-12 w-[150vw] origin-bottom-left skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 sm:mr-20 md:mr-0 lg:right-full lg:-mr-36 lg:origin-center" />
          <figure className="grid grid-cols-1 items-center gap-x-6 gap-y-8 lg:gap-x-10">
            <div className="relative col-span-2">
              <svg
                viewBox="0 0 162 128"
                fill="none"
                aria-hidden="true"
                className="absolute -top-12 left-0 -z-10 h-32 stroke-indigo-400"
              >
                <path
                  id="b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb"
                  d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z"
                />
                <use href="#b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb" x={86} />
              </svg>
              <blockquote className="leading-8 text-gray-900 sm:text-3xl">
                <p>
                  Born from the passion of storytellers, podcast hosts, and writers, OpenSpeech is more than a platform; it's our answer to the challenges we faced as creators. We envisioned a tool that not only allows us to understand our audio narratives more deeply, but also helps to extend their reach.

                  <br></br>
                  <br></br>
                  With OpenSpeech, we're breaking down the barriers between audio and written content. We turn your podcasts into a rich source of insights, illuminating aspects like speaking time, segment analysis, and key topics. Simultaneously, we empower you to transform these insights into engaging written content - be it social media posts, blog articles, or newsletters.

                  At OpenSpeech, we're not just about making your voice heard; we're about making it resonate. With us, every story you tell is a stepping stone to your next great narrative.                </p>
              </blockquote>
            </div>
            <figcaption className="text-base">
              <div className="font-semibold text-gray-900">Raymond and Richmond Alake</div>
              <div className="mt-1 text-gray-500">Co-Founders of OpenSpeech</div>
            </figcaption>
          </figure>
        </div>
      </section>

      {/* Team section */}
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-center sm:text-4xl">
            Meet the team
          </h2>
        </div>
        <ul
          role="list"
          className="mx-auto mt-20 grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-2 xl:grid-cols-2"
        >
          {team.map((person) => (
            <li key={person.name} className="text-center">
              <Image
                className="aspect-[14/13] w-full mx-auto rounded-2xl object-cover object-top"
                src={person.imageUrl}
                alt=""
                width={360}
                height={360}
              />
              <h3 className="mt-6 text-lg font-semibold leading-8 tracking-tight ">
                {person.name}
              </h3>
              <p className="text-base leading-7 ">{person.role}</p>
              <p className="text-sm leading-6 text-gray-500">
                {person.location}
              </p>
            </li>
          ))}
        </ul>
      </div>


      {/* CTA section */}
      <div className="px-6 sm:px-6 py-24 lg:px-8 bg-indigo-700 my-12">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Want to be part of the journey?
          </h2>
          <p className="mx-auto max-w-xl mt-4 text-base text-white">
            We&apos;re always game for a chat, especially with go-getters who are as passionate about shaping the future of audio content creation as we are. Think you&apos;ve got what it takes? We&apos;re all ears.
          </p>
          <Button
            className="w-full sm:w-auto px-8 mt-4"
            href="mailto:someone@openspeech.com?subject=Join Us"
            color="white"
          >
            Join Us
          </Button>
        </div>
      </div>
    </main>
  )
}

function AboutStats() {
  const stats = [
    { id: 1, name: 'Creators on the platform', value: '8,000+' },
    { id: 2, name: 'Flat platform fee', value: '3%' },
    { id: 3, name: 'Uptime guarantee', value: '99.9%' },
    { id: 4, name: 'Paid out to creators', value: '$70M' },
  ]

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="mx-auto max-w-2xl lg:max-w-none">
        <dl className="grid grid-cols-1 gap-0.5 overflow-hidden rounded-2xl text-center sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.id} className="flex flex-col p-8">
              <dt className="text-sm font-semibold leading-6 text-gray-600">{stat.name}</dt>
              <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  )
}
